import React from 'react';
import LoadingEllipses from '../LoadingEllipses';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

export const Select = ({ id, label, options, loading, errorMessage, helper, isRequired, ...props }) => {

  let renderedErrorMessage = '';
  let errorIndicator = '';
  if (errorMessage) {
    renderedErrorMessage = (
      <p className='mt-2 text-sm text-giveRed-800' key='error-message'>
        {errorMessage}
      </p>
    );

    errorIndicator = (
      <div
        className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3'
        key='error-indicator'
      >
        <ExclamationCircleIcon className='h-5 w-5 text-giveRed-800' aria-hidden='true' />
      </div>
    );
  }

  return (
    <div className='block'>
      <label htmlFor={id} className='font-semibold'>
        {label}
      </label>
      {loading ? (
        <div className='form-select w-full h-12 shadow-sm rounded-md mt-2 pt-5 border-giveGray-200 border-solid'>
          <LoadingEllipses />
        </div>
      ) : (
        <div className='relative w-full flex'>
          <select
            id={id}
            className={`form-select py-3 w-full shadow-sm rounded-md mt-1 ${isRequired ? 'border-2' : 'border'} border-${isRequired ? 'red' : 'gray'}-300 focus:border-mint-600 focus:ring focus:ring-mint-600 focus:ring-opacity-25`}
            {...props}
          >
            {options.map((oneOption) => {
              return (
                <option key={`select-${oneOption.value}`} value={oneOption.value}>
                  {oneOption.label}
                </option>
              );
            })}
          </select>
          {errorIndicator}
        </div>
      )}
      {helper}
      {renderedErrorMessage}
    </div>
  );
};
